import { jsxs as a, jsx as e } from "react/jsx-runtime";
import * as l from "react";
import { $ as m } from "./utils-CTvPli9r.js";
import { Button as p } from "./button.js";
import { f, C as d } from "./calendar-C-HUqdjN.js";
import { Popover as h, PopoverTrigger as u, PopoverContent as y } from "./popover.js";
import { c as P } from "./createLucideIcon-Bs_bgX_W.js";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], k = P("calendar", g);
function $({ date: t, setDate: n, className: i, disabled: s }) {
  const [c, o] = l.useState(!1);
  return /* @__PURE__ */ a(h, { open: c, onOpenChange: o, children: [
    /* @__PURE__ */ e(u, { asChild: !0, children: /* @__PURE__ */ a(
      p,
      {
        variant: "outline",
        className: m(
          "w-full justify-start text-left font-normal outline-1",
          !t && "text-muted-foreground",
          i
        ),
        disabled: s,
        children: [
          /* @__PURE__ */ e(k, { className: "mr-2 size-4" }),
          t ? f(t, "PPP") : /* @__PURE__ */ e("span", { children: "Pick a date" })
        ]
      }
    ) }),
    /* @__PURE__ */ e(y, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ e(
      d,
      {
        mode: "single",
        selected: t,
        onSelect: (r) => {
          r && (n(r), o(!1));
        },
        initialFocus: !0
      }
    ) })
  ] });
}
export {
  $ as DatePicker
};
//# sourceMappingURL=date-picker.js.map
